<template>
    <div class="spinner-outer">
        <div :class="['spinner-border', 'text-primary', small && `spinner-border-sm`, `text-${variant}`]" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        variant: {
            type: String,
            default: 'primary'
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    setup() {
    }
})
</script>

<style scoped>
.spinner-outer {
    display: block;
    background-color: transparent;
    width: 100%;
    height: 100%;
}

.spinner {
    height: 100%;
    width: auto;
    object-fit: scale-down;
}

.visually-hidden {
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;

    &:not(caption) {
        position: absolute !important;
    }
}

.spinner-border {
    display: inline-block;
    vertical-align: -.125em;
    border-radius: 50%;
    animation: .75s linear infinite spinner-border;

    &:not(.spinner-border-sm) {
        width: 2rem;
        height: 2rem;
        border: .25em solid currentcolor;
        border-right-color: transparent;
    }

    &.spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border: .2em solid currentcolor;
        border-right-color: transparent;
    }
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg);
    }
}
</style>
